import { useContext } from "react";
import FormContext from "../../context/FormContext";
import { useNavigate } from "react-router-dom";
import { ReactSession } from "react-client-session";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const ReconcilationHandler = ({ row }) => {
  const { setIsLoading } = useContext(FormContext);
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const clickHandler = async (row) => {
    setIsLoading(true);
    console.log(row);
    const id = row.stockists_master_id;
    ReactSession.set("box_id", id);
    try {
      const res = await axiosPrivate.get(`reconcilation/reconcile/${id}`);
      if (res.data.bool === false) {
        ReactSession.set("order_type", row.order_type);
        navigate("/upload");
        return;
      } else if (res.data.bool === true) {
        navigate("/reconcilation", { state: { data: res.data } });
        return;
      } else {
        navigate("/reconciled-report", { state: { data: res.data.data } });
        return;
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={() => clickHandler(row)}
      className="table-options-btn"
      disabled={
        row.indicator["reconciliation_status"] === undefined ||
        row.indicator["reconciliation_status"] === false
          ? false
          : true
      }
    >
      RC
    </button>
  );
};

export default ReconcilationHandler;
